import axios from 'axios';
import {V1API} from "../../../_helpers/APIPath";
import {encode, decode} from "../../dataMagic";
import {populateStore, performNetworkCall, buildFormData} from "@/store/asyncHelper";


const keyList = {
    smsUpdate : 'CRM_DASHBOARD_UPDATE',
    smsDelete : 'CRM_DASHBOARD_DELETE'
};

const mutations = {};
const store = {};

populateStore(store, mutations, keyList, false);

export default {
    namespaced: true,
    state : {

        stats : [],
        targets_list:[],
        submitLoading: false,
        submitError: false,
        submitSuccess: false,

        ...store
    },
    mutations : {
        ...mutations,
        SET_TARGET_STATS(state, stats) {
            state.stats = stats;
        },
        SET_TARGET_TABLE(state, targets_list) {
            state.targets_list = targets_list;
        },

        SUBMIT_LOADING (state, loading) {
            state.submitLoading = loading;
        },
        SUBMIT_ERROR (state, hasError) {
            state.submitError = hasError;
        },

        SUBMIT_SUCCESS (state, success) {
            state.submitSuccess = success;
        }
    },

    actions: {

        

        async fetchTargetStats ({ commit }) {
            commit('SUBMIT_LOADING', true);
            commit('SUBMIT_ERROR', false);

            let config = {
                headers: {
                  Authorization: "Bearer " + localStorage.getItem("access_token"),
                }
            };

            try{
                let result = await axios.get(V1API.get_targets_state, config);
                let response = result.data.data
              
                commit('SET_TARGET_STATS', response);

            } catch(error) {
                commit('SUBMIT_ERROR', true);
            }
            finally {
                commit('SUBMIT_LOADING', false);
            }
        },

        async fetchTargetTable ({ commit },payload) {
            commit('SUBMIT_LOADING', true);
            commit('SUBMIT_ERROR', false);

            let config = {
                headers: {
                  Authorization: "Bearer " + localStorage.getItem("access_token"),
                }
            };

            try{
                let params = new URLSearchParams();
        
                if (payload.team) params.append('team', payload.team);
                if (payload.year) params.append('year', payload.year);
           
                let url = V1API.get_targets_table + '?' + params.toString();
                let result = await axios.get(url, config);

                let response = result.data.data

                commit('SET_TARGET_TABLE', response);
                return result
              

            } catch(error) {
                commit('SUBMIT_ERROR', true);
            }finally {
                commit('SUBMIT_LOADING', false);
            }
           
        },


        
        
        async addTarget ({commit, dispatch}, payload) {
            commit('SUBMIT_LOADING', true);
            commit('SUBMIT_ERROR', false);
            let config = {
                headers: {
                  Authorization: "Bearer " + localStorage.getItem("access_token"),
                },
            };
            try{
                let response = await axios.post(V1API.target_create, payload.target, config).then(result=>{
                    let data = result.data
                    return data
                });
            
                dispatch ('fetchTargetTable',{team:payload.team, year: payload.year})
                return response

            }catch (e) {
                commit('SUBMIT_ERROR', true);
            }finally {
                commit('SUBMIT_LOADING', false);
            }
        },


        async targetBulkUpdate ({commit, dispatch}, payload) {
          
            let config = {
                headers: {
                  Authorization: "Bearer " + localStorage.getItem("access_token"),
                },
            };
            try{
                let response = await axios.patch(V1API.target_bulk_update, payload.changedData, config).then(result=>{
                    let data = result.data
                    return data
                });
            
                dispatch ('fetchTargetTable',{team:payload.team, year: payload.year})
                return response

            }catch (e) {
                
            }finally {
               
            }
        },
       
        

        

        


  
    },

    getters: {}
}
